module.exports = __webpack_public_path__ + "img/logo_ua_old.d708c3bb.png";